import { render, staticRenderFns } from "./gd-dlysjg-vehicle-datas.vue?vue&type=template&id=d91843ca&scoped=true"
import script from "./gd-dlysjg-vehicle-datas.vue?vue&type=script&lang=js"
export * from "./gd-dlysjg-vehicle-datas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91843ca",
  null
  
)

export default component.exports